"use client";

import { useEffect } from "react";
import { worldBus } from "@/lib/world-bus";
import { markSecret } from "./runtime";

// Pide al mundo la escena de la 404 (el árbol que duda) y anota el secreto. WorldRoot
// pone el modo de la ruta antes (va antes en el árbol), así que este gana.
export function LostScene() {
  useEffect(() => {
    worldBus.setMode("lost");
    markSecret("404");
  }, []);
  return null;
}
